
import { Pagination } from "swiper";

export default {
  props: { siteReview: { type: Array, default: () => [] } },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        slidesPerGroup: 1,
        slidesPerView: "auto",
        loop: false,
        loopFillGroupWithBlank: false,
        modules: [Pagination],
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.mobile-reviewes", this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(".swiper.mobile-reviewes");
  },
};
